export const apolloURL = process.env.REACT_APP_GRAPHQL_URL;
